import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../theme';

const { colors, breakpoints } = redesignTheme;

export const useEditSidebarStyles = makeStyles(() => ({
  chapterSidebar: {
    flex: '0 0 284px',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    borderRight: `1px solid ${colors.tabBorder}`,
    backgroundColor: colors.background,
    overflowY: 'auto',
    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      flex: '0 0 220px',
    },
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      display: 'none',
    },
  },
  chapterList: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
  },
}));
